import React from 'react'
import classNames from 'classnames'
import { clamp } from 'lodash-es'

import Badge from '@material-ui/core/Badge'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import { withStyles, WithStyles, createStyles, Theme } from '@material-ui/core/styles'

import level0Icon from './assets/level_0.svg'
import level1Icon from './assets/level_1.svg'
import level2Icon from './assets/level_2.svg'
import level3Icon from './assets/level_3.svg'
import level4Icon from './assets/level_4.svg'
import level5Icon from './assets/level_5.svg'
import level6Icon from './assets/level_6.svg'

interface Props {
  level: number
  size?: 'small' | 'medium' | 'large'
  checked?: boolean
  className?: string
}

const levelIconUrls = [
  level0Icon,
  level1Icon,
  level2Icon,
  level3Icon,
  level4Icon,
  level5Icon,
  level6Icon,
]

const styles = (theme: Theme) => {
  const badgeHeights = {
    small: 32,
    medium: 64,
    large: 114,
  }

  return createStyles({
    root: {
      textAlign: 'center',
    },
    check: {
      top: 20,
      right: 10,
      backgroundColor: theme.palette.common.white,
      width: 16.67,
      height: 16.67,
    },
    small: {
      height: badgeHeights.small,
    },
    medium: {
      height: badgeHeights.medium,
    },
    large: {
      height: badgeHeights.large,
    },
    small_locked: {
      height: badgeHeights.small * .75,
    },
    medium_locked: {
      height: badgeHeights.medium * .75,
    },
    large_locked: {
      height: badgeHeights.large * .75,
    },
  })
}

type InjectedProps = Props & WithStyles<typeof styles>

const AchievementBadge: React.SFC<InjectedProps> = ({ className, checked, level, size, classes }) => {
  level = clamp(level | 0, 0, 6) // tslint:disable-line:no-bitwise

  return (
    <div className={classNames(className, classes.root)}>
      <Badge
        classes={{ badge: classes.check }}
        component="div"
        invisible={!checked}
        badgeContent={<CheckCircleIcon fontSize="small" />}
      >
        <img
          alt=""
          src={levelIconUrls[level]}
          className={classNames({
            small: size === 'small',
            small_locked: size === 'small' && !level,
            medium: !size || size === 'medium',
            medium_locked: (!size || size === 'medium') && !level,
            large: size === 'large',
            large_locked: size === 'large' && !level,
          })}
        />
      </Badge>
    </div>
  )
}

export default withStyles(styles)(AchievementBadge)
